"use strict";

exports.__esModule = true;
exports.CreateTicketActionDialog = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Logbook = require("../../Logbook");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CreateTicketDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "CreateTicketActionDialog__CreateTicketDialog",
  componentId: "sc-1nlvp3f-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);

/**
 * Provides a function to a render prop which opens the operator panel
 * screen for the selected device.
 */
var CreateTicketActionDialog = exports.CreateTicketActionDialog = function CreateTicketActionDialog(props) {
  var label = props.label;
  var logbook = _react["default"].useContext(_Logbook.LogbookContext);
  return /*#__PURE__*/_react["default"].createElement(CreateTicketDialog, {
    isOpen: props.isOpen,
    onClose: props.toggleDialog,
    title: label
  }, /*#__PURE__*/_react["default"].createElement(_Logbook.NewLogbookTicketForm, {
    device: logbook.device,
    filteredTicketTypes: logbook.filteredTicketTypes,
    ticketTypes: logbook.nonDeviceTicketTypes,
    onClose: props.toggleDialog
  }));
};